/**
 * This exception is fired when total audio duration exceeds the max limit after an audio item is added.
 * A trim modal is shown in this case
 */
export class AudioDurationExceededOnAddException extends Error {
  public audioItemId: string;

  constructor(audioItemId: string) {
    super();
    this.audioItemId = audioItemId;
  }
}
